import React, {Component} from "react";
import CanvasDraw from "react-canvas-draw";
import GeneralHeader from "components/Headers/GeneralHeader";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Label
} from "reactstrap";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import download from 'downloadjs';
import { jsPDF } from "jspdf";

var htmlToImage = require('html-to-image');

class MarkedScriptView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: "#FF0000",
            width: 600,
            height: 800,
            brushRadius: 2,
            lazyRadius: 1,
            upload_id: this.props.match.params.upload_id,
            images: [],
            imagesLoading: true,
            currentPage: this.props.match.params.page_number,
            currentImagePos: 0,           
            student_id:'',
            pdf_available:false,
            checking_pdf:true,
            marked:true,
            generated_pages:0
        };
       
        this.goToNext = this.goToNext.bind(this);
        this.getTempScripts = this.getTempScripts.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
        this.downloadScript = this.downloadScript.bind(this);
        this.generatePDFandDownload = this.generatePDFandDownload.bind(this);
        this.checkForPDF = this.checkForPDF.bind(this);
        this.editScript = this.editScript.bind(this);
        this.saveAnnotation = this.saveAnnotation.bind(this);
    }

    componentDidMount() { // let's change the color randomly every 2 seconds. fun!
        // //console.log('Check Scriptview state', this.state);
        this.getTempScripts();
        this.checkForPDF();
    }

    checkForPDF(){
        let token = localStorage.getItem('access_token');
        console.log('checking for PDF',token);
        if(this.state.currentPage==1){
            let cur = this;
            axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/check-downloaded-pdf/' + cur.props.match.params.upload_id, {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
            }).then(res => {
                console.log('current pdf', res.data);
                if(res.data.images>1){
                    cur.setState({pdf_available:true,checking_pdf:false,generated_pages:res.data.images});
                }           
              
            }).catch(error => {
                // //console.log('error', error);
            });
        }else{
            let cur = this;
            axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/check-downloaded-pdf-page/' + cur.props.match.params.upload_id+'/'+cur.state.currentPage, {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
            }).then(res => {
                console.log('current pdf', res.data);
                if(res.data.available){
                    cur.setState({pdf_available:true,checking_pdf:false});
                }           
              
            }).catch(error => {
                // //console.log('error', error);
            }); 
        }
        
    }

    goToNext() {
        let current_image_pos = this.state.currentImagePos + 1;
        let current_page = Number(this.state.currentPage) + 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;

        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/view_marked/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    generatePDFandDownload(){
        let token = localStorage.getItem('access_token');
        console.log('generating pdf for download',token);

        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/generate-and-download/' + cur.props.match.params.upload_id, {
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
        }).then(res => {
            console.log('current pdf', res.data);
            download('https://markerportalbackend.thinkdigitalacademy.org/'+res.data.path);
          
        }).catch(error => {
            // //console.log('error', error);
        });
    }

    downloadScript(){
        let cur = this;
        // let options = {width:200,height:400};
        htmlToImage.toPng(document.getElementById('canvas'))
        .then(function (dataUrl) {
            // console.log('check',dataUrl);
            // download(dataUrl, 'my-node.jpg');
            // const pdf = new jsPDF();
            // pdf.addImage(dataUrl, 'PNG', 0, 0);
            // let current_page = Number(cur.state.currentPage);
            // pdf.save("student_dowload_page_"+current_page+'.pdf'); 
            let data = {
                page_number:cur.state.currentPage,
                image_text:dataUrl,
                student_id:cur.state.student_id,
                upload_id: cur.state.upload_id
            };
            axios({
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
                method: 'post',
                url: 'https://markerportalbackend.thinkdigitalacademy.org/api/save-base-image',
                data: data
            }).then(res => {
                console.log(res);                
                toast(res.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: toast.TYPE.SUCCESS
                });
    
            }).catch(error => {
                let error_result = error.response;
                //console.log(error_result);
                toast('Error occurred. ' + error_result, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: toast.TYPE.ERROR
                });
            });
        });
    }

    goToPrevious() {
        let current_image_pos = Number(this.state.currentImagePos) - 1;
        let current_page = Number(this.state.currentPage) - 1;
        // //console.log('clicked go to next', current_page);
        this.state.currentImagePos = current_image_pos;
        this.state.currentPage = current_page;

        this.setState({currentImagePos: current_image_pos, currentPage: current_page});
        // //console.log("checking script state", this.state.images[this.state.currentImagePos]);
        window.location.href = '/admin/view_marked/' + this.state.upload_id + '/' + this.state.currentPage;
    }

    getTempScripts() {
        let token = localStorage.getItem('access_token');
        // //console.log('getting temporal scripts',token);
        let cur = this;
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-temp-scripts/' + cur.props.match.params.upload_id + '/' + cur.props.match.params.page_number, {
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
        }).then(res => {
            // //console.log('current scripts', res.data);
            this.setState({images: res.data.images, student_id: res.data.student_id, imagesLoading: false, annotation: res.data.annotation});
            cur.loadableCanvas.loadSaveData(this.state.annotation);
        }).catch(error => {
            // //console.log('error', error);
        });
    }

    saveAnnotation() {
        const data = {
            annotation: this.saveableCanvas.getSaveData(),
            upload_id: this.props.match.params.upload_id,
            student_id: this.state.student_id,
            page_number: this.props.match.params.page_number,
            picture_url: this.state.images[this.state.currentPage - 1]
        };

        let cur = this;

        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'post',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/update-annotated-script',
            data: data
        }).then(res => {
            // //console.log(res);
            // //console.log(res.data);
            // //console.log('save annotaion', res.data);
            cur.setState({annotation: res.data.script.annotation});
            cur.loadableCanvas.loadSaveData(cur.state.annotation);
            toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });

        }).catch(error => {
            let error_result = error.response;
            //console.log(error_result);
            toast('Error occurred. ' + error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    editScript(){
        // this.setState({marked:false});
        let cur = this;
        window.open('/admin/edit_marked/'+ cur.props.match.params.upload_id + '/' + cur.props.match.params.page_number, "_blank")
    }
    
    render() {
        return (
            <div>
                <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
                <ToastContainer/>
                <GeneralHeader/>
                <Container className="mt--7" fluid>
                    <Row>
                        <Col className="order-xl-1" xl="12">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row>
                                    {
                                        this.state.checking_pdf?<Loader type="ThreeDots" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={3000}
                                        //3 secs
                                    />:<>{
                                        this.state.currentPage==1?<Col md={12}><Label>A marked PDF is available for this document. A total of {this.state.generated_pages} pages were generated for download.</Label></Col>:
                                        <Col md={12}><Label>PDF version for this page available, you can re-generate or please proceed to next page.</Label></Col>
                                    }</>
                                    }
                                    </Row>
                                    
                                    <Row>                                       
                                        {
                                        this.state.currentPage == 1 ? <><Col md={8}>
                                            <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.goToNext
                                            }>
                                                Next
                                            </Button>
                                            {
                                            this.state.marked && <Button size="sm" color="primary" type="button"
                                            onClick={
                                                this.editScript
                                        }>
                                            edit
                                        </Button>
                                        }
                                        {
                                                !this.state.marked &&<>
                                                <Button onClick={
                                                    this.saveAnnotation
                                                }
                                                size="sm"
                                                color="success"
                                                type="button">
                                                Save
                                            </Button>
                                            <Button size="sm" color="warning" type="button"
                                            onClick={
                                                () => {
                                                    this.saveableCanvas.undo();
                                                }
                                        }>
                                            Undo
                                        </Button>
                                        <Button size="sm" color="danger" type="button"
                                                onClick={
                                                    () => {
                                                        this.saveableCanvas.clear();
                                                        this.saveAnnotation();
                                                    }
                                            }>
                                                Clear
                                            </Button>
                                        </>
                                            }

                                   <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.downloadScript
                                                 }>
                                                Convert to Pdf
                                            </Button><Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.generatePDFandDownload
                                                }>
                                                    Download Script
                                                </Button>
                                            <Label>{
                                                'Page ' + this.state.currentPage + 'of' + this.state.images.length
                                            }</Label>
                                        </Col>
                                        
                                        {
                                            this.state.pdf_available &&  <Button size="sm" color="info" type="button"
                                            onClick={
                                                this.generatePDFandDownload
                                            }>
                                            Download Script
                                            </Button>
                                        } </> : <>
                                            <Col md={10}>
                                                <Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.goToPrevious
                                                }>
                                                    Previous
                                                </Button>
                                                {
                                            this.state.marked && <><Button size="sm" color="primary" type="button"
                                            onClick={
                                                this.editScript
                                        }>
                                            edit
                                        </Button>
                                        
                                        </>
                                        }
                                                {
                                                this.state.currentPage != this.state.images.length && <Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.goToNext
                                                }>
                                                    Next
                                                </Button>
                                                
                                            }
                                            {
                                                !this.state.marked &&<>
                                                <Button onClick={
                                                    this.saveAnnotation
                                                }
                                                size="sm"
                                                color="success"
                                                type="button">
                                                Save
                                            </Button>
                                           
                                        <Button size="sm" color="warning" type="button"
                                        onClick={
                                            () => {
                                                this.saveableCanvas.undo();
                                            }
                                    }>
                                        Undo
                                    </Button>
                                    <Button size="sm" color="danger" type="button"
                                            onClick={
                                                () => {
                                                    this.saveableCanvas.clear();
                                                    this.saveAnnotation();
                                                }
                                        }>
                                            Clear
                                        </Button></>
                                            }
                                            <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.downloadScript
                                            }>
                                                Convert to Pdf
                                            </Button>
                                                <Label>{
                                                    'Page ' + this.state.currentPage + 'of' + this.state.images.length
                                                }</Label>
                                                {
                                                    this.state.currentPage == this.state.images.length &&  <Button size="sm" color="info" type="button"
                                                    onClick={
                                                        this.generatePDFandDownload
                                                }>
                                                    Download Script
                                                </Button>
                                                }
                                                
                                            </Col>
                                           
                                        </>
                                    } </Row>
                                    
                                </CardHeader>
                                <CardBody>
                                    {
                                        !this.state.marked?
                                        <div>
                                            {
                                    this.state.imagesLoading ? <Loader type="Puff" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={5000}
                                        //3 secs
                                    /> : <div>
                                        <Row>
                                            <Col md={12}>
                                                <header>Marking Pad</header>
                                                <CanvasDraw ref={
                                                        canvasDraw => (this.saveableCanvas = canvasDraw)
                                                    }
                                                    brushColor={
                                                        this.state.color
                                                    }
                                                    brushRadius={
                                                        this.state.brushRadius
                                                    }
                                                    lazyRadius={
                                                        this.state.lazyRadius
                                                    }
                                                    canvasWidth={
                                                        0.75*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.75*this.state.height
                                                    }
                                                    loadTimeOffset={0}
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }/>
                                                </Col>
                                            
                                        </Row>
                                        <Row>
                                        <header>Preview Tab (Ignore)</header>
                                        
                                        <CanvasDraw hidden disabled hideGrid
                                                    canvasWidth={
                                                        0.75*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.75*this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/>
                                        </Row>
                                    </div>
                                }
                                        </div>:
                                        <div>{
                                            this.state.imagesLoading ? <Loader type="Puff" color="#00BFFF"
                                        height={100}
                                        width={100}
                                        timeout={5000}
                                        //3 secs
                                    /> : <div>
                                     <Row>
                                        <Col md={12}>
                                                <header>Marked Script Preview</header>
                                                <div id='canvas'>
                                                <CanvasDraw disabled hideGrid
                                                    canvasWidth={
                                                        0.60*this.state.width
                                                    }
                                                    canvasHeight={
                                                        0.60*this.state.height
                                                    }
                                                    imgSrc={
                                                        `https://admin.thinkdigitalacademy.org/` + this.state.images[this.state.currentPage - 1]
                                                    }
                                                    ref={
                                                        canvasDraw => (this.loadableCanvas = canvasDraw)
                                                    }/></div>
                                                    <br/>
                                                    {/* <Button size="sm" color="info" type="button"
                                                onClick={
                                                    this.showpreViewDialog
                                            }>
                                                View Full Preview
                                            </Button> */}
                                                    </Col>
                                        </Row>
                                        </div>
                                            }
                                            
                                        </div>
                                    }
                                      </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>

            </div>
        );
    }
};
export default MarkedScriptView;
